import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import numeral from 'numeral';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import NoteAdd from '@material-ui/icons/NoteAdd';
import Clear from '@material-ui/icons/Clear';
import History from '@material-ui/icons/History';
import DeleteIcon from '@material-ui/icons/Delete';
import CircularProgress from '@material-ui/core/CircularProgress';
import FileUpload from '@material-ui/icons/FileUpload';
import Modal from '@material-ui/core/Modal';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import SignatureCanvas from 'react-signature-canvas'
import List from '@material-ui/core/List';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormGroup from '@material-ui/core/FormGroup';
import { v4 } from 'uuid';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import LineItem from './LineItem';
import Document from './Document';
import { startFetchDivisions, startFetchExpenseAccounts, startRemoveEntry, startFetchVendors } from '../../actions';
import AutoComplete from '../shared/AutoComplete';
import { convertIdToName } from '../../helpers/convertIdToName';
import ErrorBar from '../shared/ErrorBar';

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = theme => ({
  root: {
  width: '100%',
  marginTop: theme.spacing.unit * 3,
  overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  button: {
    margin: theme.spacing.unit / 1.25,
  },
  input: {
    display: 'none',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  menu: {
    width: 200,
  },
  formControl: {
    margin: theme.spacing.unit * 1.25,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  paper: {
     position: 'absolute',
     width: theme.spacing.unit * 90,
     backgroundColor: theme.palette.background.paper,
     boxShadow: theme.shadows[5],
     padding: theme.spacing.unit * 4,
  },
});

const NOW = moment();
export class EntryForm extends Component {

  static propTypes = {
    onFormActionSubmit: PropTypes.func.isRequired,
    divisions: PropTypes.array.isRequired,
    expense_accounts: PropTypes.array.isRequired,
  }

  state = {
    //status
    submitFormProgress: 0,
    isSubmittingForm: false,
    didFormSubmissionComplete: false,
    deleteConfirmation: false,
    //form data
    request_from: '',
    effective_date: NOW,
    created_at: NOW,
    vendor_id: '',
    purpose: '',
    partial_receipt: false,
    regular_book: 'regular_book',
    division_id: '1',
    entry_type: 'disbursement',
    calenderFocused: false,
    selectedEntryDocumentations: [],
    line_items: [{ id: v4(), description: '', amount: '', expense_account_id: '1' }],
    updated_at: '',
    signature: null,
    errMessages: this.props.errMessages,
    emptyCanvas: false,
    audit: null,
    last_changed_by: null,
    logOpened: false
  };

  componentWillMount() {
    // this.props.startFetchExpenseAccounts();
    // this.props.startFetchDivisions();
    // this.props.startFetchVendors();
    if (this.props.entry) {
      console.log(this.props.entry);
      this.setState(() => ({
        ...this.props.entry,
        regular_book: this.props.entry.regular_book ? 'regular_book' : 'cash_book',
        selectedEntryDocumentations: this.props.entry.documentations,
        effective_date: moment(this.props.entry.effective_date),
        division_id: this.props.entry.division_id ? this.props.entry.division_id : 1,
        created_at: moment(this.props.entry.created_at),
      }));
    }
  }
  componentDidMount() {
    this.setState({
      emptyCanvas: this.sigCanvas.isEmpty()
    });
    this.handleBinding();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      errMessages: nextProps.errMessages,
      loading: nextProps.loading,
      emptyCanvas: this.sigCanvas.isEmpty()
    });
  }

  onFormChange = e => {
    const key = e.target.name;
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    this.setState({ [key]: value });
  };

  onVendorSelect = vendor => {
    const vendor_id = this.props.vendors.filter(dataSet => {
      return dataSet.vendor_name.toLowerCase() === vendor.toLowerCase()
    });
    this.setState({ vendor_id: vendor_id[0].id.toString() });
  }


  onDateChange = (effective_date) => {
    if (effective_date) {
      this.setState({
        effective_date
      });
    }
  };
  onCalenderFocus = ({ focused }) => {
    this.setState({
      calenderFocused: focused
    });
  }

  onDeleteButtonClick = () => {
    this.props.startRemoveEntry({ id: this.props.entry.id });
  };

  onSubmit = e => {
    const { request_from, effective_date, vendor_id, purpose, entry_type, division_id, partial_receipt, regular_book, line_items, selectedEntryDocumentations } = this.state;
    e.preventDefault();

    // if (entry_type === 'disbursement' && (!request_from || !effective_date || !vendor || !purpose)) {
    //   this.setState({
    //     error: 'Missing field'
    //   });
    // } else {
      // this.setState({
      //   errMessage: ''
      // });
    // if (emptySig) {
    //   const newErrMessages = [
    //     ...this.state.errMessages, 'Signature cannot be empty'
    //   ]
    //   return this.setState({
    //     errMessages: newErrMessages
    //   });
    // } else {
    const emptySignature = this.sigCanvas.isEmpty() ? true : this.sigCanvas.getCanvas().toDataURL();
    return this.props.onFormActionSubmit({
      request_from,
      entry_type,
      vendor_id,
      purpose,
      effective_date: effective_date.format(),
      partial_receipt,
      division_id,
      regular_book: regular_book === 'regular_book',
      line_items,
      selectedEntryDocumentations,
      signature: emptySignature
    });
  }

  onEntryTypeChange = e => {
    this.setState({
      entry_type: e.target.value
    });
  }

  onBookChange = e => {
    this.setState({
      regular_book: e.target.value
    });
  }

  //**** line item form handlers ****//
  /**
    * accepted form attributes
    @param {string} [description
    @param {string} [amount]
    @param {string} [expense_account_id]
    @return {Array}
  */

  onLineItemFormChange = (id) => (e) => {
    const newline_items = this.state.line_items.map((lineItem) => {
      if (id !== lineItem.id) return lineItem;
      const key = e.target.name;
      const value = e.target.value;
      return { ...lineItem, [key]: value };
    });

    this.setState({ line_items: newline_items });
  }

  onLineItemAutoCompleteChange = id => (e) => {
    const newline_items = this.state.line_items.map((lineItem) => {
      if (id !== lineItem.id) return lineItem;
      const value = this.props.expense_accounts.filter(dataSet => {
        return dataSet.account_name.toLowerCase() === e.toLowerCase()
      });
      return { ...lineItem, expense_account_id: value[0].id.toString() };
    });
    this.setState({ line_items: newline_items });
  }

  onAmountChange = (id) => e => {
    // let amount = e.target.value.replace(/^0+/, '');
    let amount = e.target.value;
    if (!amount || amount.match(/^\d{1,}(\.\d{0,2})?$/)) {
      const newline_items = this.state.line_items.map((lineItem) => {
        if (id !== lineItem.id && parseFloat(amount) > 0) return lineItem;
        return { ...lineItem, amount };
      });
      this.setState({ line_items: newline_items });
    }
  };

  onAddLineItem = () => {
    this.setState({
      line_items: [
        ...this.state.line_items, {
          id: v4(),
          description: '',
          amount: '',
          expense_account_id: '1'
        }
      ]
    });
  }

  onRemoveLineItem = (item, index) => () => {
    // this.setState({
    //   line_items: this.state.line_items.filter((lineItem) => id !== lineItem.id)
    // });
    const { line_items } = this.state;
    if (item.created_at) {
      // cover file that has been uploaded will be marked as destroy
      line_items[index]._destroy = true;
    } else {
      line_items.splice(index, 1);
    }

    this.setState({
      line_items
    });
  }

  renderTotal() {
    const { line_items, entry_type } = this.state;
    return line_items.map(item => !item._destroy ? (parseFloat(item.amount, 10) || 0) : 0).reduce((total, amount) => {
        if (entry_type === 'disbursement' || entry_type === 'hand_in') {
            return total - Math.abs(amount);
        }
        return total + amount;
    }, 0);
  }
  //**** Get total from line_items ****//
  /**
    * accepted form attributes
    @param {array} [line_items.each.amount]
    @return {number} [Sum of line items]
  */

  onClearSignature = () => {
    this.sigCanvas.clear();
  }

  onEntryDocumentationsChange = (e) => {
    //Get Image from Upload Field
    const selectedFiles = this.entryAttachmentsField.files;
    const { selectedEntryDocumentations } = this.state;

    //Loop through files field to get each images into object
    for (let i = 0; i < selectedFiles.length; i++) {
      //assign tempID for removal
      const doc = Object.assign(selectedFiles.item(i), { tempId: v4() });
      selectedEntryDocumentations.push(doc);
    }

    //Set files into state for display

    this.setState(
        {
          selectedEntryDocumentations
        },
      () => {
        this.entryAttachmentsField.value = null;
      }
    );
  }

  onOpenLog = () => {
     this.setState({ logOpened: true });
  }

  onCloseLog = () => {
    this.setState({ logOpened: false });
  };


  onRemoveSelectedEntryDocumentations = (documentation, index) => {
    const { selectedEntryDocumentations } = this.state;
    if (documentation.id) {
      // cover file that has been uploaded will be marked as destroy
      selectedEntryDocumentations[index]._destroy = true;
    } else {
      selectedEntryDocumentations.splice(index, 1);
    }

    this.setState({
      selectedEntryDocumentations
    });
  }
  getNumberOfSelectedAttachments = () => {
    return this.state.selectedEntryDocumentations.filter(doc => {
      return doc._destroy !== true;
    }).length;
  }

  handleDeleteConfirmationOpen = () => {
    this.setState({ deleteConfirmation: true });
  };

  handleDeleteConfirmationClose = () => {
    this.setState({ deleteConfirmation: false });
  };

  handleCloseError = (remove) => {
    const newErrMessages = this.state.errMessages.filter((errMessage, index) => index !== remove)
    this.setState({
      errMessages: newErrMessages
    });
  }

  handleBinding() {
    if (this.props.editMode && !!this.state.signature) {
      this.sigCanvas.fromDataURL(this.state.signature);
      if (!this.state.emptyCanvas) {
        this.sigCanvas.off();
      }
    }
  };

  renderSelectedEntryDocumentations = () => {
    const unAuthorized = this.props.editMode && this.props.role !== 'admin';
    const fileDOMs = this.state.selectedEntryDocumentations.map((doc, index) => {
      if (doc._destroy) { // we use _destroy to mark the removed photo
        return null;
      }

      return (
        <Document key={index} doc={doc} index={index} onRemoveSelectedEntryDocumentations={this.onRemoveSelectedEntryDocumentations} unAuthorized={unAuthorized} />
      );
    });

    return (

      <Grid container spacing={40}>
        <List>
          {fileDOMs}
        </List>
      </Grid>
    );

  }

  renderUploadDocumentationsButton() {
    const numberOfSelectedCovers = this.getNumberOfSelectedAttachments();
    return (
      <div>
        <input
          name="documents[]"
          ref={field => (this.entryAttachmentsField = field)}
          type="file"
          disabled={this.state.isSubmittingForm}
          multiple
          accept="image/*, application/pdf"
          id="raised-button-file"
          onChange={this.onEntryDocumentationsChange}
          className={this.props.classes.input}
        />
        <label
          disabled={this.state.isSubmittingForm}
          htmlFor="raised-button-file"
        >
          <Button variant="raised" component="span" color="primary" className={this.props.classes.button}>
            {numberOfSelectedCovers === 0
              ? 'Upload Files'
              : `${numberOfSelectedCovers} file${numberOfSelectedCovers !== 1
                  ? 's'
                  : ''} selected`}
          </Button>
        </label>

      </div>
    );
  }

  renderLineItems = () => {
    const unAuthorized = this.props.editMode && this.props.role !== 'admin';
    let accountType = ""
    if (this.state.entry_type === 'cash_in') {
      accountType = 'cash_in'
    } else if (this.state.entry_type === 'hand_in') {
      accountType = 'hand_in'
    } else {
      accountType = 'disbursement'
    }
    const expenseAccounts = this.props.expense_accounts.filter(account => account.account_type === accountType);

    const lineItems = this.state.line_items.map((lineItem, index) => {
      if (lineItem._destroy) { // we use _destroy to mark the removed photo
        return null;
      }


      return <LineItem key={lineItem.id} index={index} lineItem={lineItem} onLineItemFormChange={this.onLineItemFormChange} onLineItemAutoCompleteChange={this.onLineItemAutoCompleteChange} onAmountChange={this.onAmountChange} onFormChange={this.onFormChange} onRemoveLineItem={this.onRemoveLineItem} expenseAccounts={expenseAccounts} unAuthorized={unAuthorized} />;
    });
    return (
      <Paper className={this.props.classes.root}>
        <Table className={this.props.classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Account</TableCell>
              <TableCell>Memo</TableCell>
              <TableCell numeric>Amount</TableCell>
              <TableCell>Remove</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lineItems}
            <TableRow>
              <TableCell />
              <TableCell />
              <TableCell numeric>
                <Typography variant="display1" gutterBottom align="right">
                  {numeral(this.renderTotal()).format('$0,0.00')}
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {unAuthorized ? '' :
          <Button variant="raised" id="lineitem-btn" className={this.props.classes.button} onClick={this.onAddLineItem}>
            <NoteAdd className={this.props.classes.leftIcon} aria-label="Add Line Item" />
            Add LineItem
          </Button>
        }
      </Paper>
    );
  }

  renderRemoveButton() {
    if (this.props.editMode) {
      if (this.props.role === 'admin') {
        return (
          <span>
            {this.renderConfirmationBox()}
            <Button
              className={this.props.classes.button}
              variant="raised"
              color="secondary"
              onClick={
                  this.handleDeleteConfirmationOpen
              }
            >
              <DeleteIcon className={this.props.classes.leftIcon} aria-label="Remove" />
              Remove
            </Button>
          </span>
        );
      }
    }
  }

  renderHistoryButton() {
    if (this.props.editMode && this.state.audit) {
      return <Button className={this.props.classes.button} variant="raised" onClick={this.onOpenLog} ><History className={this.props.classes.leftIcon} aria-label="Remove" /> Log</Button>;
    }
  }

  renderDisbursementForm() {
    const { request_from, vendor_id, purpose, partial_receipt, division_id } = this.state;
    const { classes, editMode, role } = this.props;
    const unAuthorized = editMode && role !== 'admin';
    if (this.state.entry_type === 'disbursement') {
      return (
        <div>
          {/* Vendor */}
          {/* <TextField
            disabled={unAuthorized}
            className={classes.textField}
            name="vendor"
            label="Vendor"
            placeholder="Vendor"
            margin="normal"
            value={vendor}
            onChange={this.onFormChange}
          /> */}
        <AutoComplete suggestionCount={15} data={this.props.vendors} dataKey={'vendor_name'} unAuthorized={unAuthorized} onItemSelect={this.onVendorSelect} value={convertIdToName(vendor_id, this.props.vendors, "vendor_name")} fieldLabel="Vendor"/>
        <FormGroup row>
          {/* From */}
          <TextField
            className={classes.textField}
            name="request_from"
            id="with-placeholder"
            disabled={unAuthorized}
            label="From"
            placeholder="From"
            margin="normal"
            autoFocus value={request_from}
             onChange={this.onFormChange}
          />

          {/* Purpose */}
          <TextField
            disabled={unAuthorized}
            className={classes.textField}
            name="purpose"
            label="Purpose"
            placeholder="Purpose"
            margin="normal"
            value={purpose}
            onChange={this.onFormChange}
          />

          {/* Division */}
          <TextField
            disabled={unAuthorized}
            name="division_id"
            select
            label="Divisions"
            className={classes.textField}
            value={division_id}
            onChange={this.onFormChange}
            SelectProps={{
              native: true,
              MenuProps: {
                className: classes.menu,
              },
            }}
            helperText="Please select division"
            margin="normal"
          >
            {this.props.divisions.map(division => {
              const { id, name, division_code } = division;
              return (
              <option key={id} value={id}>
                {name}
              </option>
            )}) }
          </TextField>
        </FormGroup>

          {/* Partial? */}
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={unAuthorized}
                  name="partial_receipt"
                  type="checkbox"
                  checked={partial_receipt}
                  onChange={this.onFormChange}
                  value="partial_receipt"
                  color="primary"
                />
              }
              label="Partial Receipt"
            />
          </FormGroup>
          {/* Documents */}
          {unAuthorized ? '' : this.renderUploadDocumentationsButton()}
          {this.renderSelectedEntryDocumentations()}
        </div>
      );
    }
    // {/* Purpose */}
    return (<TextField
      disabled={unAuthorized}
      className={classes.textField}
      name="purpose"
      label="Purpose"
      placeholder="Purpose"
      margin="normal"
      value={purpose}
      onChange={this.onFormChange}
    /> );
    // else {
    //   return (
    //     <div>
    //       <RadioGroup
    //         aria-label="regular_book"
    //         name="regular_book"
    //         className={classes.group}
    //         value={regular_book}
    //         onChange={this.onBookChange}
    //       >
    //         <FormControlLabel value='regular_book' control={<Radio color="primary" />} label="Regular Book" />
    //         <FormControlLabel value='cash_book' control={<Radio color="secondary" />} label="Cash Book" />
    //       </RadioGroup>
    //     </div>
    //   );
    // }
  }

  renderConfirmationBox() {
    return (
      <Dialog
          open={this.state.deleteConfirmation}
          onClose={this.handleDeleteConfirmationClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Are you sure you want to delete this entry?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Removal of entry is an irreverable process.  Alternatively, you can choose to create an adjusting entry to correct any change.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDeleteConfirmationClose} color="secondary">
              Cancel
            </Button>
            <Button variant="raised" onClick={this.onDeleteButtonClick} color="primary" autoFocus>
              Proceed to Remove
            </Button>
          </DialogActions>
        </Dialog>
    );
  }

  renderSignature() {
    let signature;
    if (!this.props.editMode || (this.props.editMode && !Boolean(this.state.signature))) {
      return (
        <Paper style={{ width: 400, height: 180, marginTop: 30, position: 'absolute', right: 80, zIndex: 10 }}>
          <Button mini variant="fab" id="clear-sig-btn" aria-label="Clear Signature" color="secondary" className={this.props.classes.button} onClick={this.onClearSignature} style={{ position: 'absolute' }}>
            <Clear />
          </Button>
          {/* {signature} */}
          <SignatureCanvas
            penColor='black'
            backgroundColor='white'
            clearButton="true"
            canvasProps={{ width: 400, height: 180, className: 'sigCanvas' }} ref={(ref) => { this.sigCanvas = ref }}
          />
          <Typography variant="subheading" gutterBottom className={this.props.classes.leftIcon}>
            Please Sign Here
          </Typography>
        </Paper>
      )
    }
    return (
      <Paper style={{ width: 400, height: 180, marginTop: 30, position: 'absolute', right: 80 }}>
      <SignatureCanvas penColor='black' clearButton="true" backgroundColor='transparent'
             canvasProps={{ width: 800, height: 360, className: 'sigCanvas' }} ref={(ref) => { this.sigCanvas = ref }}
      />
      </Paper>
    );
  }
  renderErrMessages() {
    return <ErrorBar messages={this.state.errMessages} onClick={this.handleCloseError} />;
  }

  renderHistory() {
    const { audit, last_changed_by, line_items } = this.state;
    const handler = last_changed_by ? last_changed_by.name : 'Admin'
    if (this.props.editMode && this.state.audit) {
      if (this.state.audit.action === 'create') {
        return `Created by ${handler} at ${moment(this.state.created_at).format('MM/DD/YY h:mm:ss a')}`;
      } else if (this.state.audit.action === 'update') {
        const histories = Object.entries(audit.audited_changes).map((history) => {
          return <Typography key={history[0]} variant="body1">{`${history[0]} from ${history[1][0]} to ${history[1][1]} at ${moment(audit.audited_changes.created_at).format('MM/DD/YY h:mm:ss a')}`}</Typography>;
        });
        const lineItemHistories = line_items.map((line_item) => {
          if (line_item.audit) {
            if (line_item.audit.action === 'create') {
              return Object.entries(line_item.audit.audited_changes).map((history) => {
                return <Typography key={history[0]} variant="body1">{`${line_item.audit.action} ${history[1]} to ${history[0]} at ${moment(line_item.audit.audited_changes.created_at).format('MM/DD/YY h:mm:ss a')}`}</Typography>;
              });
            } else if (line_item.audit.action === 'update') {
              return Object.entries(line_item.audit.audited_changes).map((history) => {
                return <Typography key={history[0]} variant="body1">{`${line_item.audit.action} ${history[0]} from ${history[1][0]} to ${history[1][1]} at ${moment(line_item.audit.audited_changes.created_at).format('MM/DD/YY h:mm:ss a')}`}</Typography>;
              });
            }
          }
        });
        return (
          <div>
            <div>
              {`The following are the latest ${audit.action}s made by ${handler}:`}
            </div>
            {histories}
            {lineItemHistories}
            <br />
            <Typography variant="body1">
              {`Please contact 646-578-1040 for full change log`}
            </Typography>
          </div>
        );
      }
    }
  }

  render() {
    const { classes, editMode, role } = this.props;
    const { effective_date, calenderFocused, entry_type, created_at, updated_at, emptyCanvas} = this.state;
    const unAuthorized = editMode && role !== 'admin';
    return (
      <div>
      <form>

        <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
          {/* Effective Date */}
          <div style={{ flex: 4 }}>
            <Typography variant="caption" gutterBottom className={classes.leftIcon}>
              Effective Date

              <SingleDatePicker
                disabled={unAuthorized}
                date={effective_date}
                onDateChange={this.onDateChange}
                focused={calenderFocused}
                onFocusChange={this.onCalenderFocus}
                id='effective-date'
                numberOfMonths={1}
                small
                showDefaultInputIcon
                isOutsideRange={() => false}
              />
            </Typography>
          </div>
            {/* Poisted Date */}
          <div style={{ flex: 1 }}>
            <Typography variant="caption" gutterBottom>
              Posted Date
            <SingleDatePicker
              disabled
              small
              date={created_at}
              onDateChange={() => {}}
              onFocusChange={() => {}}
              readOnly
            />
            </Typography>
          </div>

        </div>
        {/* Entry Type */}
        <FormGroup row>
        {unAuthorized ?
          <Typography variant="title" gutterBottom className={classes.leftIcon}>
            Entry Type: {entry_type}
          </Typography>
          : <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend">Entry Type</FormLabel>
            <RadioGroup
              row
              aria-label="entry_type"
              name="entry_type"
              className={classes.group}
              value={entry_type}
              onChange={this.onEntryTypeChange}
            >
              <FormControlLabel value="disbursement" control={<Radio color="primary" />} label="Disbursement" />
              {this.props.role === 'admin' ? <FormControlLabel value="hand_in" control={<Radio color="secondary" />} label="Hand In" /> : ''}
              <FormControlLabel value="cash_in" control={<Radio color="primary" />} label="Cash In" />
            </RadioGroup>
          </FormControl>}
          {
            this.renderSignature()
          }
        </FormGroup>
        {
          this.renderDisbursementForm()
        }

        {
          this.renderLineItems()
        }

        <Button variant="raised" disabled={this.props.loading || (editMode && !emptyCanvas)} color="primary" className={classes.button} onClick={this.onSubmit}>
          {this.props.loading ? <CircularProgress className={classes.progress} size={25} /> :
          <FileUpload className={classes.leftIcon} aria-label={editMode ? 'Update' : 'Create'} />
          }
          { editMode ? 'Update' : 'Create' }
        </Button>
        {
          this.renderRemoveButton()
        }
        {
          this.renderHistoryButton()
        }
      </form>
      {/* {
        editMode ? `Last updated at ${moment(updated_at).format('MM/DD/YY')}` : ''
      } */}
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.logOpened}
          onClick={this.onCloseLog}
        >
        <div style={getModalStyle()} className={classes.paper}>
          <Typography variant="headline" gutterBottom>
          {
            this.renderHistory()
          }
          </Typography>
        </div>
      </Modal>

      {
        this.renderErrMessages()
      }
    </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // startFetchDivisions: () => dispatch(startFetchDivisions()),
    // startFetchVendors: () => dispatch(startFetchVendors()),
    // startFetchExpenseAccounts: () => dispatch(startFetchExpenseAccounts()),
    startRemoveEntry: (entry) => dispatch(startRemoveEntry(entry))
  };
};

const mapStateToProps = ({ divisions, expense_accounts, auth, errors, appLoading, vendors }) => {
  const { errMessage } = errors;
  const { loading } = appLoading;
  const errMessages = errMessage.split(", ")[0] === "" ? [] : errMessage.split(", ");
  const { role } = auth;
  return {
    vendors,
    loading,
    divisions,
    expense_accounts,
    role,
    errMessages
  };
};

export default compose(
  withStyles(styles, {
    name: 'EntryForm',
}), connect(mapStateToProps, mapDispatchToProps))(EntryForm);



// WEBPACK FOOTER //
// ./src/components/entries/EntryForm.js